import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function SmartRedirect() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/signin" />;
  }

  // Redireciona todos os usuários para a página inicial
  return <Navigate to="/home" />;
}
